query OrganizationUsersList(
  $page: Int
  $rowsPerPage: Int
  $filter: OrganizationUsersFilterInput
) {
  organizationUsers(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      roles
      disabled
      welcomeEmailSentAt
      createdAt
      user {
        id
        email
        displayName
      }
    }
  }
}
